import { render } from "./ChatRoomSelection.vue?vue&type=template&id=5dcee4fa"
import script from "./ChatRoomSelection.vue?vue&type=script&lang=js"
export * from "./ChatRoomSelection.vue?vue&type=script&lang=js"
script.render = render

export default script